import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-slate-900 text-slate-300 py-12 border-t border-slate-800 pb-24 md:pb-12" data-id="element-85">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-86">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 lg:gap-12" data-id="element-87">
          {/* Brand Col */}
          <div className="md:col-span-5 lg:col-span-4" data-id="element-88">
            <div className="mb-6" data-id="element-89">
              <img src="https://lynjoneslogistics.com/wp-content/uploads/lynjones-logistics-Final.png" alt="LynJones Logistics" className="h-14 w-auto object-contain bg-white rounded-lg p-2" data-id="element-90" />
            </div>
            <p className="text-sm text-slate-400 mb-6 leading-relaxed" data-id="element-91">
              Nationwide heavy equipment transport and machinery hauling
              specialists. Fully licensed, bonded, and insured for your complete
              peace of mind.
            </p>
            <div className="space-y-3" data-id="element-92">
              <a href="tel:+17543251100" className="flex items-center gap-3 text-sm hover:text-white transition-colors" data-id="element-93">
                <Phone className="w-4 h-4 text-brand-red" data-id="element-94" />
                (754) 325-1100
              </a>
              <div className="flex items-center gap-3 text-sm" data-id="element-95">
                <Mail className="w-4 h-4 text-brand-red" data-id="element-96" />
                quotes@lynjoneslogistics.com
              </div>
              <div className="flex items-center gap-3 text-sm" data-id="element-97">
                <MapPin className="w-4 h-4 text-brand-red" data-id="element-98" />
                Serving all 50 US States & International
              </div>
            </div>
          </div>

          {/* Services Col */}
          <div className="md:col-span-4 lg:col-span-4" data-id="element-99">
            <h4 className="text-white font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-100">
              Our Services
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-101">
              <li data-id="element-102">
                <a href="#" className="hover:text-brand-red transition-colors" data-id="element-103">
                  Oversize / Super-Load Hauling
                </a>
              </li>
              <li data-id="element-104">
                <a href="#" className="hover:text-brand-red transition-colors" data-id="element-105">
                  International Shipping
                </a>
              </li>
              <li data-id="element-106">
                <a href="#" className="hover:text-brand-red transition-colors" data-id="element-107">
                  Tractor & Farm Equipment
                </a>
              </li>
              <li data-id="element-108">
                <a href="#" className="hover:text-brand-red transition-colors" data-id="element-109">
                  Excavator & Construction
                </a>
              </li>
              <li data-id="element-110">
                <a href="#" className="hover:text-brand-red transition-colors" data-id="element-111">
                  Bulldozer & Dozer Hauling
                </a>
              </li>
            </ul>
          </div>

          {/* Legal/Trust Col */}
          <div className="md:col-span-3 lg:col-span-4" data-id="element-112">
            <h4 className="text-white font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-113">
              Company
            </h4>
            <ul className="space-y-3 text-sm mb-6" data-id="element-114">
              <li data-id="element-115">
                <a href="#" className="hover:text-brand-red transition-colors" data-id="element-116">
                  About Us
                </a>
              </li>
              <li data-id="element-117">
                <a href="#" className="hover:text-brand-red transition-colors" data-id="element-118">
                  Contact
                </a>
              </li>
              <li data-id="element-119">
                <a href="#" className="hover:text-brand-red transition-colors" data-id="element-120">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-121">
                <a href="#" className="hover:text-brand-red transition-colors" data-id="element-122">
                  Terms of Service
                </a>
              </li>
            </ul>
            <div className="bg-slate-800 p-4 rounded-lg border border-slate-700 inline-block" data-id="element-123">
              <p className="text-xs font-semibold text-white mb-1" data-id="element-124">
                DOT Registered
              </p>
              <p className="text-xs text-slate-400" data-id="element-125">
                MC #1234567 • USDOT #7654321
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-12 pt-8 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-126">
          <p className="text-xs text-slate-500 text-center md:text-left" data-id="element-127">
            &copy; {new Date().getFullYear()} LynJones Logistics. All rights
            reserved.
          </p>
          <p className="text-xs text-slate-500 text-center md:text-right" data-id="element-128">
            Designed for secure and reliable heavy equipment hauling nationwide.
          </p>
        </div>
      </div>
    </footer>;
}